export class ServiceRequest {
    "SR Number": string = "";
    "SR Type": string = "";
    "SR Sub Type": string = "";
    "CSN": string = "";
    "Amount": string = "";
    "DC Channel": string = "Online";
    "DC Language": string = "ENU";
}

export class ListOfDCCreatePaymntSRIO {
    "Service Request": ServiceRequest = new ServiceRequest();
}

export class DCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DCCreatePaymntSRIO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCCreatePaymntSRIO: ListOfDCCreatePaymntSRIO =
        new ListOfDCCreatePaymntSRIO();
}

export class PaymentServiceBody {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "CREATE";
    DCLanguage: string = "ENU";
    DCLoginName: string = "";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class PaymentServiceRequest {
    body: PaymentServiceBody = new PaymentServiceBody();
}
